import { Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import { HeaderTableCellX } from 'framework/table/HeaderTableCellX';
import { SortableHeaderTableCellX } from 'framework/table/SortableHeaderTableCellX';
import { IQueryResult, ISortParams, ITender } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { TenderTableRow } from './TenderTableRow';
import { NoContentTableHeadX } from 'framework/table/NoContentTableHeadX';

interface IProps {
	queryResult: IQueryResult<ITender>;
	sortParams: ISortParams<ITender>;
	onFilter: (sp: ISortParams<ITender>) => void;
	expandedId: string | undefined;
	expandAll: boolean;
	toggle: (id: string) => void;
}

export const TendersTable = ({ queryResult, sortParams, onFilter, expandedId, expandAll, toggle }: IProps) => {
	const strings = useLocalization();

	return (
		<Table stickyHeader>
			{queryResult.unfilteredCount === 0 && <NoContentTableHeadX>{strings.noTendersRegisteredYet}</NoContentTableHeadX>}
			{queryResult.unfilteredCount > 0 && (
				<TableHead>
					<TableRow>
						<SortableHeaderTableCellX<ITender>
							isFirst
							forProperty='reference'
							sortParams={sortParams}
							onFilter={onFilter}>
							{strings.reference}
						</SortableHeaderTableCellX>
						<SortableHeaderTableCellX<ITender>
							forProperty='created'
							sortParams={sortParams}
							onFilter={onFilter}>
							{strings.date}
						</SortableHeaderTableCellX>
						<HeaderTableCellX>{strings.customer}</HeaderTableCellX>
						<SortableHeaderTableCellX<ITender>
							forProperty='priceInVat'
							onFilter={onFilter}
							sortParams={sortParams}
							align='right'>
							{`${strings.totalAmount} (${strings.inVatShort})`}
						</SortableHeaderTableCellX>
						<HeaderTableCellX isLast></HeaderTableCellX>
					</TableRow>
				</TableHead>
			)}
			<TableBody>
				{queryResult.values.map(t => (
					<TenderTableRow
						key={t.id}
						item={t}
						isExpanded={expandedId === t.id || expandAll}
						toggle={() => toggle(t.id)}
					/>
				))}
			</TableBody>
		</Table>
	);
};
